webpackJsonp([177976741496010],{

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ColumbusImageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(12);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _HeroSmall = __webpack_require__(8);
	
	var _HeroSmall2 = _interopRequireDefault(_HeroSmall);
	
	var _LocationMicroNav = __webpack_require__(10);
	
	var _LocationMicroNav2 = _interopRequireDefault(_LocationMicroNav);
	
	var _LocationContent = __webpack_require__(9);
	
	var _LocationContent2 = _interopRequireDefault(_LocationContent);
	
	var _LocationRelated = __webpack_require__(11);
	
	var _LocationRelated2 = _interopRequireDefault(_LocationRelated);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ColumbusLocation = function (_React$Component) {
	  _inherits(ColumbusLocation, _React$Component);
	
	  function ColumbusLocation() {
	    _classCallCheck(this, ColumbusLocation);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  ColumbusLocation.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_HeroSmall2.default, { location: 'Columbus, OH' }),
	      _react2.default.createElement(_LocationMicroNav2.default, null),
	      _react2.default.createElement(_LocationContent2.default, {
	        category: 'E-bikes',
	        title: 'Buckeye Breakthrough',
	        story: 'We testified in support of HB 250 in the Ohio State Legislature\'s House Transportation and Public Safety Committee to update the state\'s e-bike law. Seven organizations supported this bill: PFB and BPSA, Rails-to-Trails Conservancy, Central Ohio Mountain Biking Organization, Five Rivers Metro Parks, Friends of Little Miami State Park, and Bike Miami Valley along with two retailers and two riders. Testifying on these bills provides us an opportunity to answer questions and educate legislators in person.'
	      }),
	      _react2.default.createElement(_gatsbyImage2.default, {
	        title: 'ColumbusOH',
	        alt: 'Ebike breakthrough',
	        sizes: this.props.data.columbusImage.sizes
	      }),
	      _react2.default.createElement(_LocationRelated2.default, {
	        prevLocationName: 'California',
	        prevLocationPath: 'california',
	        prevLocationImgPath: this.props.data.columbusPrevImage,
	        nextLocationName: 'Portland, OR',
	        nextLocationPath: 'portland',
	        nextLocationImgPath: this.props.data.columbusNextImage
	      })
	    );
	  };
	
	  return ColumbusLocation;
	}(_react2.default.Component);
	
	exports.default = ColumbusLocation;
	
	// GraphQL query
	
	var ColumbusImageQuery = exports.ColumbusImageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-columbus-js-ed9d71cb95680d4d502b.js